export default {
  main: '#101820',
  secondary: '#EEBA04',
  contrastingColor: '#ffffff',
  priceColor: '#EEBA04',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
